<div class="partner-subscription-offer-dialog">
  <div class="partner-subscription-offer-dialog__glow partner-subscription-offer-dialog__glow--1" aria-hidden="true"></div>
  <div class="partner-subscription-offer-dialog__glow partner-subscription-offer-dialog__glow--2" aria-hidden="true"></div>

  <div class="partner-subscription-offer-dialog__inner">
    <gus-generic-dialog>
      <gus-dialog-header>
        <div class="partner-subscription-offer-dialog__top" gusCustomDialogContent>
          <div
            class="partner-subscription-offer-dialog__top-bg"
            role="img"
            [attr.aria-label]="paywallImageAriaLabel"
            [style.background-image]="paywallBackgroundImageCss"
          ></div>
          <span class="partner-subscription-offer-dialog__paywall-save-badge">Save 50%</span>
        </div>
      </gus-dialog-header>

      <gus-dialog-body>
        <ng-container gusCustomDialogContent>
          <h2 class="partner-subscription-offer-dialog__title text-transform-uppercase gus-font-demi-bold">
            Ready to Go Goomi?
          </h2>

          <p class="partner-subscription-offer-dialog__subtitle">
            You're in the right place. Let's get you set up.
          </p>

          <hr class="partner-subscription-offer-dialog__divider" />

          <div class="partner-subscription-offer-dialog__list-panel">
            <ul class="partner-subscription-offer-dialog__list gus-font-light space-letter-047 line-height-24 fs16">
              <li class="partner-subscription-offer-dialog__list-item">
                <span class="partner-subscription-offer-dialog__list-marker" aria-hidden="true">
                  <img class="partner-subscription-offer-dialog__list-check-img" src="/icons/check.svg" alt="" />
                </span>
                <span>Unlimited access to 500+ classes</span>
              </li>
              <li class="partner-subscription-offer-dialog__list-item">
                <span class="partner-subscription-offer-dialog__list-marker" aria-hidden="true">
                  <img class="partner-subscription-offer-dialog__list-check-img" src="/icons/check.svg" alt="" />
                </span>
                <span>Guided programs &amp; collections</span>
              </li>
              <li class="partner-subscription-offer-dialog__list-item">
                <span class="partner-subscription-offer-dialog__list-marker" aria-hidden="true">
                  <img class="partner-subscription-offer-dialog__list-check-img" src="/icons/check.svg" alt="" />
                </span>
                <span>Unlock all premium content</span>
              </li>
            </ul>
          </div>

          <div class="partner-subscription-offer-dialog__pricing">
            <div class="partner-subscription-offer-dialog__pricing-row">
              <span class="partner-subscription-offer-dialog__strike-wrap">
                <span class="partner-subscription-offer-dialog__strike-text partner-subscription-offer-dialog__price-amount">$99</span>
                <span class="partner-subscription-offer-dialog__strike-line" aria-hidden="true"></span>
              </span>
              <span class="partner-subscription-offer-dialog__pricing-trailing"> year</span>
            </div>
            <div class="partner-subscription-offer-dialog__pricing-row partner-subscription-offer-dialog__pricing-row--deal">
              <div class="partner-subscription-offer-dialog__pricing-deal-main">
                <span class="partner-subscription-offer-dialog__price-amount">$49</span>
                <span class="partner-subscription-offer-dialog__pricing-trailing"> for your first year</span>
              </div>
              <span class="partner-subscription-offer-dialog__pricing-save-badge">Save 50%</span>
            </div>
          </div>

          <hr class="partner-subscription-offer-dialog__divider" />
        </ng-container>
      </gus-dialog-body>

      <gus-dialog-footer>
        <div class="partner-subscription-offer-dialog__footer" gusCustomDialogContent>
          <wlcm-button type="paddingless" class="partner-subscription-offer-dialog__skip-btn" (clicked)="skip()">
            <span>SKIP</span>
          </wlcm-button>

          <wlcm-button
            class="design-button partner-subscription-offer-dialog__cta-btn"
            (clicked)="start()"
            [isLoading]="loading()"
            [isDisabled]="loading()"
          >
            <span>START FOR $49</span>
          </wlcm-button>
        </div>
      </gus-dialog-footer>
    </gus-generic-dialog>
  </div>
</div>
